// extracted by mini-css-extract-plugin
export default {"main":"avatar_main__vOkXm","image":"avatar_image__Pj9F4","initialsDiv":"avatar_initialsDiv__cOyGl"};